<template>
  <div id="app">
    <!--<div id="nav" style="background-color: rgba(255,180,0,0.1);">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand>
        <h2>SisCol - Transcripción</h2>
      </b-navbar-brand>
      <template v-if="user!=='Usuario'">
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown>
          <template slot="button-content"><b-avatar class="mr-2"></b-avatar>{{user}}</template>
          <b-dropdown-item href="#"><b-icon icon="person" variant="info" class="mr-2"></b-icon>Perfil</b-dropdown-item>
          <b-dropdown-item href="/"><b-icon icon="power" variant="info" class="mr-2"></b-icon>Salir</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      </template>
    </b-navbar>
    <b-container fluid>
      <router-view/>
    </b-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  /*watch: {
    '$route' (to, from) {
      console.log('WATCH IN APP de:', from)
      console.log('a:', to)
    }
  },*/ 
  computed: {
    ...mapState(['user'])
  }
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.breadcrumb-item > a, .breadcrumb-item > a:hover {
  color: #10181f;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: ">" !important;
}

</style>